'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var PropTypes = require('prop-types');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var StyledTabHeading = /*#__PURE__*/react.styled('div')({
  name: "StyledTabHeading",
  "class": "s1anuq3l",
  propsAsIs: false
});
var StyledTabHeaderItem = /*#__PURE__*/react.styled('li')({
  name: "StyledTabHeaderItem",
  "class": "sj0we1t",
  propsAsIs: false
});
var StyledTabPanels = /*#__PURE__*/react.styled('div')({
  name: "StyledTabPanels",
  "class": "s1l7r0n7",
  propsAsIs: false
});

var propTypes = {
  /** Array of Tab objects to display on the page */
  tabs: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    button: PropTypes__default["default"].string.isRequired,
    content: PropTypes__default["default"].any.isRequired,
    isDefault: PropTypes__default["default"].bool
  }).isRequired).isRequired,
  /** Additional classes to pass to the component */
  className: PropTypes__default["default"].string,
  /** Determines whether to center the tab buttons */
  isCentered: PropTypes__default["default"].bool,
  /** A visible label that will appear to the left of the tabs */
  label: PropTypes__default["default"].string,
  /** Aria label for the tab buttons */
  tabsAriaLabel: PropTypes__default["default"].string.isRequired,
  /** This function is called when the tabs are changed */
  onChange: PropTypes__default["default"].func,
  /** An element to add to the right side of the tab buttons */
  rightSideHeaderContent: PropTypes__default["default"].node
};
var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    isCentered = _ref.isCentered,
    label = _ref.label,
    tabsAriaLabel = _ref.tabsAriaLabel,
    className = _ref.className,
    onChange = _ref.onChange,
    rightSideHeaderContent = _ref.rightSideHeaderContent;
  var _useState = React.useState(0),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    activeTabIndex = _useState2[0],
    setActiveTabIndex = _useState2[1];
  React.useEffect(function () {
    if (tabs) {
      var defaultIndex = tabs.findIndex(function (tab) {
        return tab.isDefault;
      });
      setActiveTabIndex(defaultIndex > -1 ? defaultIndex : 0);
    }
  }, [tabs]);
  var updateIsActive = function updateIsActive(activeTab, index) {
    if (activeTab === index) {
      return true;
    }
    return false;
  };

  // Accessability Markup Helpers
  var setPanelId = function setPanelId(index) {
    return "panel-".concat(index + 1);
  };
  var setTabId = function setTabId(index) {
    return "tab-".concat(index + 1);
  };
  var setTabableIndex = function setTabableIndex(isActive) {
    return isActive ? 0 : -1;
  };

  // Keyboard Navigation
  var handleKeyPress = function handleKeyPress(event) {
    var firstTab = 0;
    var lastTab = tabs.length - 1;
    if (event.key === 'ArrowLeft') {
      handleNextTab(lastTab, activeTabIndex - 1, firstTab);
    }
    if (event.key === 'ArrowRight') {
      handleNextTab(firstTab, activeTabIndex + 1, lastTab);
    }
  };
  var handleNextTab = function handleNextTab(first, next, last) {
    var tabToSetActive = activeTabIndex === last ? first : next;
    onChange === null || onChange === void 0 ? void 0 : onChange(tabToSetActive);
    setActiveTabIndex(tabToSetActive);
  };
  var tabButtons = tabs.reduce(function (array, item, index) {
    var button = item.button;
    var setActive = function setActive() {
      onChange === null || onChange === void 0 ? void 0 : onChange(index);
      setActiveTabIndex(index);
    };
    var isActive = updateIsActive(activeTabIndex, index);
    var panelId = setPanelId(index);
    var tabId = setTabId(index);
    var tabIndex = setTabableIndex(isActive);
    array.push( /*#__PURE__*/jsxRuntime.jsx(StyledTabHeaderItem, {
      className: isActive ? 'active' : '',
      children: /*#__PURE__*/jsxRuntime.jsx("button", {
        onClick: setActive,
        role: "tab",
        "aria-selected": isActive,
        "aria-controls": panelId,
        id: tabId,
        tabIndex: tabIndex,
        onKeyDown: handleKeyPress,
        children: button
      })
    }, index));
    return array;
  }, []);
  var tabLabel = label && /*#__PURE__*/jsxRuntime.jsx("div", {
    children: label
  });
  var tabPanels = tabs.reduce(function (array, item, index) {
    var content = item.content;
    var isActive = updateIsActive(activeTabIndex, index);
    var panelId = setPanelId(index);
    var tabId = setTabId(index);
    array.push( /*#__PURE__*/jsxRuntime.jsx(StyledTabPanels, {
      role: "tabpanel",
      id: panelId,
      "aria-labelledby": tabId,
      className: activeTabIndex === index ? '' : 'hidden',
      hidden: !isActive,
      children: content
    }, index));
    return array;
  }, []);
  return /*#__PURE__*/jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.jsxs(StyledTabHeading, {
      className: "tab-heading",
      children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
        className: "left-heading-content",
        children: [tabLabel, /*#__PURE__*/jsxRuntime.jsx("ul", {
          className: "tab-buttons ".concat(isCentered ? 'centered' : '', " ").concat(className || ''),
          role: "tablist",
          "aria-label": tabsAriaLabel,
          children: tabButtons
        })]
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "right-heading-content",
        children: rightSideHeaderContent
      })]
    }), tabPanels[activeTabIndex]]
  });
};
Tabs.propTypes = propTypes;

exports["default"] = Tabs;
